import styles from "../css/AlbumDetails.module.css";
import back from '../statics/images/back.png';
import search from '../statics/images/search.png';
import { ImageForm } from "./ImageForm";
import { PhotoCard } from "./PhotoCard";
import { UpdateImageForm } from "./UpdateImageForm";
import { ViewImage } from "./ViewImage";
import { SearchBar } from "./SearchBar";
import cross from '../statics/images/cross.png';
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { photofolioActions, photofolioSelector } from "../redux/reducers/reducers";

export function AlbumDetails() {
    const dispatch = useDispatch();
    const {
        addImageFormToggle,
        updateImgFormToggle,
        viewImageToggle,
        searchIconToggle,
        searchedText,
        currentAlbumOBJ,
        currImagesForSlides,
        currImgIdx,
    } = useSelector(photofolioSelector);

    useEffect(() => {
        console.log('currImgIdx from AlbumDetails :', currImgIdx);
    }, [currentAlbumOBJ]);

    const handleImageFormToggle = () => {
        dispatch(photofolioActions.handleImageFormToggle());
    };

    const handleUpdateImgFormToggle = () => {
        dispatch(photofolioActions.updateImgFormToggleHandle());
    };

    const handleViewImageToggle = () => {
        dispatch(photofolioActions.viewImageToggleHandle());
    };

    const handleSearchIconToggle = () => {
        dispatch(photofolioActions.searchIconToggleHandle());
        dispatch(photofolioActions.searchedTextHandle(""));
    };

    const handleSearchedTextChange = (text) => {
        dispatch(photofolioActions.searchedTextHandle(text));
    };

    const handleCancelFormToggle = async () => {
        if (addImageFormToggle) {
            dispatch(photofolioActions.handleImageFormToggle());
        } else if (updateImgFormToggle) {
            dispatch(photofolioActions.updateImgFormToggleHandle());
        }
    };
    
    const handleAlbumToggle = () => {
        dispatch(photofolioActions.handleAlbumToggle())
    }

    // Function to filter images based on searched text
    const filteredImages = currentAlbumOBJ.images.filter(imgOBJ =>
        imgOBJ.text.toLowerCase().includes(searchedText.toLowerCase())
    );



    return (
        <div className={styles.container}>
            {viewImageToggle && <ViewImage imagesUrls={currImagesForSlides} currImgIdx={currImgIdx}/>}
            {addImageFormToggle && <ImageForm currentAlbumOBJ={currentAlbumOBJ} />}
            {updateImgFormToggle && <UpdateImageForm currentAlbumOBJ={currentAlbumOBJ} currImgIdx={currImgIdx} />}

            <div className={styles.upperBox}>
                <span id={styles.backButton} onClick={handleAlbumToggle}><img src={back} alt="back" className={styles.back} /></span>
                <h4>Your Albums, {currentAlbumOBJ.text}</h4>
                <div className={styles.searchDiv}>
                    {searchIconToggle ? (
                        <>
                            <SearchBar searchedText={searchedText} onSearchTextChange={handleSearchedTextChange}/>
                            <span onClick={handleSearchIconToggle} className={styles.searchIcon}><img src={cross} alt="cross" className={styles.search}/></span>
                        </>
                    ) : (
                        <span onClick={handleSearchIconToggle} className={styles.searchIcon}><img src={search} alt="search" className={styles.search} /></span>
                    )}
                </div>
                {addImageFormToggle || updateImgFormToggle ? (
                    <button id={styles.cancel} onClick={handleCancelFormToggle}>Cancel</button>
                ) : (
                    <button id={styles.addAlbum} onClick={handleImageFormToggle}>Add image</button>
                )}
            </div>

            <div className={styles.albumBox}>
                {filteredImages && filteredImages.map((imgOBJ, index) => (
                    <PhotoCard
                        key={index}
                        imgOBJ={imgOBJ}
                        index={index} 
                        handleUpdateImgFormToggle={handleUpdateImgFormToggle}
                        handleViewImageToggle={handleViewImageToggle}
                        filteredImages={filteredImages}
                    />
                ))}
            </div>
        </div>
    );
}
